import React, { useState } from 'react';
import { Box, Paper, Typography, Button, Alert, CircularProgress } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import api from '../axiosConfig';
import { downloadBlob } from './exportUtils';
 
export const IncomeExport = ({ setMessage = () => {}, setMessageType = () => {} }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState(null);
 
  const handleExport = async () => {
    setIsProcessing(true);
    setError(null);
 
    try {
      const response = await api.get('/csv/export/income', { responseType: 'blob' });
      downloadBlob(response, 'income_export.csv');
      setMessageType('success');
      setMessage('Income data exported.');
    } catch (err) {
      console.error('Export error:', err);
      setError(err.response?.data?.error || 'An error occurred during export');
      setMessageType('error');
      setMessage('Error exporting income data. Please try again.');
    } finally {
      setIsProcessing(false);
    }
  };
 
  return (
    <Paper elevation={3} sx={{ p: 3, maxWidth: 1200, margin: '0 auto' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5">Income Export</Typography>
      </Box>
 
      <Alert severity="info" sx={{ mb: 3 }}>
        <Typography variant="body2">
          Exports one row per employee per sales type (service/product), matching what the
          system has recorded. Payment type (cash/card) is only stored as a daily total, not
          per line, so that column is left blank in the export rather than guessed.
        </Typography>
      </Alert>
 
      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}
 
      <Button
        startIcon={isProcessing ? <CircularProgress size={20} /> : <DownloadIcon />}
        variant="contained"
        onClick={handleExport}
        disabled={isProcessing}
      >
        {isProcessing ? 'Preparing export...' : 'Export Income CSV'}
      </Button>
    </Paper>
  );
};
 
export default IncomeExport;